import Link from "next/link";
import React from "react";
import { Icon } from "../icons/icons";
import BackButton from "./BackButton";

const BreadCrumb = ({ data, isAppWebView }) => {
  if (data)
    return (
      <div className="bg-brand-color-primary lg:bg-brand-blue-2 w-full relative py-4 mb-6 flex items-start gap-4">
        <BackButton isAppWebView={isAppWebView} color="white" />
        <div className="container">
          <div className="pl-8 flex flex-col lg:flex-row flex-wrap items-center justify-center lg:justify-between  w-full  text-white">
            <h1 className="text-xl mm:text-2xl  lg:text-4xl font-medium">
              {data.baslik}
            </h1>
            <ul className="flex items-center gap-x-2 text-sm mm:text-base mt-1 lg:mt-0">
              <Icon name="location" className={"hidden lg:inline-block"} />
              {data.data.map((e, i) => (
                <li
                  key={i}
                  className={i > 0 ? "before:content-['/'] before:pr-2" : ""}
                >
                  <Link href={e.url}>
                    <a title={e.title}>{e.name}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
};

export default BreadCrumb;
